module.exports = __webpack_public_path__ + "img/header-9.1e46f61b.png";